const generateInstagramLink = () => 'https://www.instagram.com/globeopinion/';

export default generateInstagramLink;
